import { render, staticRenderFns } from "./index-crypto.vue?vue&type=template&id=1a4d0454&"
import script from "./index-crypto.vue?vue&type=script&lang=js&"
export * from "./index-crypto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports